import { useFragment } from "react-relay";
import { CurrencyDisplay } from "@components/CurrencyDisplay";
import { isOrderPaid } from "@features/orders/order-paid-status";
import { useTranslation } from "@i18n/hooks";
import { type orderPriceDisplay_OrderFragment$key } from "@relay/orderPriceDisplay_OrderFragment.graphql";
import { ORDER_FRAGMENT } from "./order-price-display.graphql";
import { type OrderPriceDisplayProps } from "./order-price-display.types";

export const OrderPriceDisplay = ({ orderFragmentRef }: OrderPriceDisplayProps) => {
	const { t } = useTranslation("common");
	const order = useFragment<orderPriceDisplay_OrderFragment$key>(
		ORDER_FRAGMENT,
		orderFragmentRef,
	);

	if (isOrderPaid(order.status)) {
		const Price = order.selectedPaymentMethod?.chosenOption ? (
			<>
				{t("order.monthly")}:{" "}
				<CurrencyDisplay
					value={order.selectedPaymentMethod.chosenOption.monthlyRate.netPrice}
				/>
			</>
		) : (
			<CurrencyDisplay value={order.cart?.totals.includingAllDiscounts?.netPrice!} />
		);

		if (order.invoiceData) return Price;
	} else {
		return <div>{t("order.unpaid")}</div>;
	}
};
